/**
 * Passport Hero Types
 */

export enum CitizenLevel {
  Newcomer = 1,
  Explorer = 2,
  Voyager = 3,
  Pioneer = 4,
  Ambassador = 5,
}

export interface CitizenLevelProgress {
  currentLevel: CitizenLevel;
  nextLevel: CitizenLevel | null;
  progress: number;
  milesRemaining: number;
}
